import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса поставок 1С (срез RP-B3b `SupplyEndpoints` и операции B3c из
 * business-openapi-v1). Литерал `/api/` законен только в `api/urls.ts`
 * (eslint). rid и идентификаторы экранируются: они приходят из адреса окна.
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}/supplies`
const supply = (resourceId: string, supplyId: string) => `${base(resourceId)}/${encodeURIComponent(supplyId)}`
const line = (resourceId: string, supplyId: string, lineId: string) =>
  `${supply(resourceId, supplyId)}/lines/${encodeURIComponent(lineId)}`

export const ONEC_SUPPLY_URLS = {
  list: base,
  receipts: (resourceId: string) => `${base(resourceId)}/onec-receipts`,
  supply,
  priceTypes: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/resource/price-types`,
  clone: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/clone`,
  importInvoice: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/import`,
  lines: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/lines`,
  linesBulk: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/lines/bulk`,
  priceFactor: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/lines/price-factor`,
  line,
  linePurchasePrice: (resourceId: string, supplyId: string, lineId: string) =>
    `${line(resourceId, supplyId, lineId)}/purchase-price`,
  lineIgnored: (resourceId: string, supplyId: string, lineId: string) => `${line(resourceId, supplyId, lineId)}/ignored`,
  lineMatch: (resourceId: string, supplyId: string, lineId: string) => `${line(resourceId, supplyId, lineId)}/match`,
  lineMarkNew: (resourceId: string, supplyId: string, lineId: string) => `${line(resourceId, supplyId, lineId)}/mark-new`,
  lineAllocations: (resourceId: string, supplyId: string, lineId: string) =>
    `${line(resourceId, supplyId, lineId)}/allocations`,
  nameDecisions: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/name-decisions`,
  prices: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/prices`,
  match: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/match`,
  allocations: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/allocations`,
  allocationsValidate: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/allocations/validate`,
  defaultWarehouse: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/default-warehouse`,
  fill: (resourceId: string, supplyId: string, how: 'all-to-one' | 'evenly' | 'clear') =>
    `${supply(resourceId, supplyId)}/allocations/fill/${how}`,
  preview: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/posting-preview`,
  // --- B3c: проведение, его статус и журнал, история ---
  post: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/post`,
  postingStatus: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/posting/status`,
  postingLog: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/posting-log`,
  history: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/history`,
  fieldHistory: (resourceId: string, supplyId: string) => `${supply(resourceId, supplyId)}/history/field`,
} as const
